import React from 'react';
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {TDAForm} from "@dreebit-registry/vsm-microservice-components";
import {TypeDefinitionAttribute} from "../../types";

interface Props {
    filter: {[key: string]: any}
    attributes: TypeDefinitionAttribute[]
    onSubmit?: (values: { [p: string]: any }) => void
    onResetValues?: () => void
}

const InstalledBaseFilter = ({filter, attributes, onSubmit, onResetValues}: Props) => {
    const {t} = useTranslation();

    const rawAttributes = attributes.filter(attr => attr.index !== "search");

    // Map filter values onto attributes; normalize empty categories array so TDAForm renders them
    const filterAttributes = rawAttributes.map(attr => ({
        ...attr,
        value: filter[attr.index] ?? attr.value ?? null,
        categories: attr.categories?.length ? attr.categories : null,
    }));

    return (
        <Box
            sx={{
                overflowY: "auto",
                flexGrow: 1,
                p: "0 20px"
            }}
        >
            <TDAForm
                attributes={filterAttributes}
                onSubmit={(values) => {
                    onSubmit?.(values);
                }}
                submitButtonText={t('Save')}
                onReset={() => {
                    onResetValues?.();
                }}
                resetButtonWrapperStyles={{
                    justifyContent: "center",
                    paddingTop: "12px"
                }}
                resetButtonSxStyles={{
                    width: "100%",
                    p: "10px 16px"
                }}
                showFilterResetIcon
            />
        </Box>
    );
};

export default InstalledBaseFilter;
